import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ProductCard from "../../components/product-card/ProductCard";
import { AppContextModel } from "../../models/context/App-Context-Model";
import { Product } from '../../models/product';
import { ProductService } from "../../services/product.service";
import { AppContext } from '../../lib/app-context';
import CreateUserTweet from '../../components/create-user-tweet/CreateUserTweet';
import UserTweetList from '../../components/user-tweet-list/UserTweetList';
import { UserTweetService } from '../../services/user-tweet.service';
import { UserTweet } from '../../models/user-tweet';
import { UserService } from '../../services/user.service';
import { PublicUserResponse } from '../../models/response/public-user.response';
import UserList from '../../components/user-list/UserList';
import LazyLoad from 'react-lazyload';
import { MergeService } from '../../services/merge.service';
import './Home.scss';

import handleViewport from 'react-in-viewport';
import ViewportBlockSection from '../../components/viewport-block-section/ViewportBlockSection';
import { CommonService } from "../../services/common.service";
import { ShowqaceCategory } from "../../models/showqace-category";
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { LeftArrow, RightArrow } from "../../components/horizontal-scroll/arrows";
import { ScrollItem } from "../../components/horizontal-scroll/scroll-item";
import { ScrollProduct } from "../../components/horizontal-scroll/scroll-product";
import { formatMoney, getProductDetailUrl, getProductUrl, scrollToTop } from "../../lib/common-helper";
import ProgressiveImg from "../../components/progressive-img/ProgressiveImg";
import { ScrollShowqaceCategory } from "../../components/horizontal-scroll/scroll-showqace-category";




const ViewportBlock = handleViewport(ViewportBlockSection, null, { disconnectOnLeave: true } /** options: {}, config: {} **/);


interface IProps {
}

interface IState {
  showqaceProductCategories: ShowqaceCategory[];
  isViewAll: boolean,
  viewAllImageUrl: string,
  productFeatures: Product[],
  baseUrlFlag: string,
  flagUrlWW: string,
  defaultProductImage: string
}


export default class Home extends React.Component<IProps & any, IState> {

  static contextType = AppContext;

  mergeService: MergeService = new MergeService();
  commonService: CommonService = new CommonService();
  productService: ProductService = new ProductService();



  state: IState = {
    showqaceProductCategories: [],
    isViewAll: false,
    viewAllImageUrl: process.env.REACT_APP_SHOWQACE_CATEGORY_VIEW_ALL_IMAGE,
    productFeatures: [],
    baseUrlFlag: process.env.REACT_APP_BASE_URL_FLAG,
    flagUrlWW: process.env.REACT_APP_FLAG_URL_WW,
    defaultProductImage: process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE,
  };

  constructor(props) {
    super(props);
  }


  async componentDidMount() {
    document.title = 'Showqace | The e-showcase';

    window.scrollTo(0, 0);

    let showqaceProductCategories = await this.commonService.getShowqaceProductCategoriesThatHasItems();

    let productFeatureProducts = await this.productService.getProductFeatureProducts();

    // if (showqaceProductCategories?.length >= 4) {
    //   let viewAll: ShowqaceCategory = new ShowqaceCategory();
    //   viewAll.name = "View All";
    //   viewAll.imageFullURL = process.env.REACT_APP_SHOWQACE_CATEGORY_VIEW_ALL_IMAGE;

    //   showqaceProductCategories.splice(5, 0, viewAll);

    // }

    this.setState(
      {
        showqaceProductCategories: showqaceProductCategories,
        productFeatures: productFeatureProducts
      });


  }




  componentDidUpdate() {

  }


  productCardClicked(product: Product) {

    let redirectionUrl = getProductUrl(product);

    if (redirectionUrl) {
      window.location.href = redirectionUrl;
    }

  }

  showqaceProductCategoryClicked(showqaceProductCategory: ShowqaceCategory) {    
    window.location.href = "/category/" + showqaceProductCategory.id;
    // this.props.history.push("/category/" + showqaceProductCategory.id);
  }


  renderProductPrice(product: Product) {
    return (
      <div>
        {
          product.primaryPrice &&
          <div className="relative">
            <div className="ps-1 pe-1" style={{
              position: "absolute", bottom: 7, right: 0,
              borderRadius: "5px 0 0 5px",
              backgroundColor: "#FAFAFA", color: "#262626"
            }} >
              <span className="fs-6 d-block d-lg-none" style={{fontWeight: 500}}>
                {formatMoney(product.primaryPrice, product.primaryCurrency?.code)}
              </span>
              <span className="fs-6 d-none d-lg-block" style={{fontWeight: 500}}>
                {formatMoney(product.primaryPrice, product.primaryCurrency?.code)}
              </span>
            </div>
          </div>

        }
      </div>
    );
  }

  showqaceCategoryCardClicked(showqaceCategory: ShowqaceCategory) {
    // this.props.history.push("/category/" + showqaceCategory.id);
    window.location.href = "/category/" + showqaceCategory.id;
  }

  renderStoreLogoAndShippingCountry(publicUserResponse: PublicUserResponse) {
    return (
      <div>
        {
          publicUserResponse?.avatarFullURL &&
          <div className="relative">

            {/* <div className="ps-1 pe-1" style={{
              position: "absolute", bottom: -30, right: 35,
              backgroundColor: "transparent",
            }} >

              <img className="img-circle rounded-circle  p-0"
                src={publicUserResponse?.avatarFullURL} style={{ width: "25px", height: "25px", border: "solid #fff 1px" }} />
            </div> */}

            <div className="ps-1 pe-1" style={{
              position: "absolute", bottom: -30, right: 5,
              backgroundColor: "transparent",
            }} >

              {
                publicUserResponse.shippingCountriesIso2?.length > 0 &&
                publicUserResponse.shippingCountriesIso2[0] == "WW" &&
                <img className="img-thumbnail img-circle rounded-circle p-0"
                  src={this.state.flagUrlWW} style={{ width: "25px", height: "25px", border: "solid #fff 1px" }} />
              }

              {
                publicUserResponse.shippingCountriesIso2?.length > 0 &&
                publicUserResponse.shippingCountriesIso2[0] != "WW" &&
                <img className="img-thumbnail img-circle rounded-circle p-0"
                  src={this.state.baseUrlFlag + publicUserResponse.shippingCountriesIso2.toString().toLowerCase() + ".svg"}
                  style={{ width: "25px", height: "25px", border: "solid #fff 1px" }} />
              }


            </div>
          </div>

        }
      </div>
    );
  }




  render() {

    // To change the loading icon behavior

    return (
      <div className="" style={{ backgroundColor: "#fafafa" }} >

        {
          this.state.productFeatures?.length > 0 &&
          <div style={{ backgroundColor: "#fff", }}>
            <div className="container">
              <div className="row mb-1 p-2 pt-4"  >
                {/* <div className="col-12">
                  <h3>Product Feature</h3>
                </div> */}

                <div className="product-feature-grid-container mb-4">

                  <div className="product-feature-item1">
                    <Link to={getProductUrl(this.state.productFeatures[0])}>
                      {/* {
                    this.renderStoreLogoAndShippingCountry(this.state.productFeatures[0].publicUserResponse)
                  } */}
                      <div style={{ position: "relative" }}>
                        <div className="primary-font-color fs-7" style={{
                          position: "absolute",
                          top: "10px", left: "10px",
                          zIndex: 9, backgroundColor: "#ffba3c",
                          borderRadius: "4px",
                          padding: "0.2rem 0.5rem"
                        }}>
                          Featured
                        </div>
                      </div>
                      <ProgressiveImg
                        placeholderSrc={
                          this.state.productFeatures[0].productImage?.thumbnailImageFileName ?
                            this.state.productFeatures[0].productImage?.thumbnailImageFullURL :
                            this.state.defaultProductImage
                        }

                        src={this.state.productFeatures[0].productImage?.imageFullURL} />
                      {
                        this.renderProductPrice(this.state.productFeatures[0])
                      }

                    </Link>

                  </div>
                  {
                    this.state.productFeatures[1] &&
                    <div className="product-feature-item2">
                      <Link to={getProductUrl(this.state.productFeatures[1])}>
                        {/* {
                    this.renderStoreLogoAndShippingCountry(this.state.productFeatures[1].publicUserResponse)
                  } */}
                        {/* <img src={this.state.productFeatures[1].productImage?.imageFullURL} /> */}

                        <div style={{ position: "relative" }}>
                          <div className="primary-font-color fs-7" style={{
                            position: "absolute",
                            top: "10px", left: "10px",
                            zIndex: 9, backgroundColor: "#ffba3c",
                            borderRadius: "4px",
                            padding: "0.2rem 0.5rem"
                          }}>
                            Featured
                          </div>
                        </div>

                        <ProgressiveImg
                          placeholderSrc={
                            this.state.productFeatures[1].productImage?.thumbnailImageFileName ?
                              this.state.productFeatures[1].productImage?.thumbnailImageFullURL :
                              this.state.defaultProductImage
                          }
                          src={this.state.productFeatures[1].productImage?.imageFullURL} />
                        {
                          this.renderProductPrice(this.state.productFeatures[1])
                        }
                      </Link>
                    </div>
                  }

                  {
                    this.state.productFeatures[2] &&
                    <div className="product-feature-item3">
                      <Link to={getProductUrl(this.state.productFeatures[2])}>
                        {/* {
                    this.renderStoreLogoAndShippingCountry(this.state.productFeatures[2].publicUserResponse)
                  } */}
                        {/* <img src={this.state.productFeatures[2].productImage?.imageFullURL} /> */}

                        <div style={{ position: "relative" }}>
                          <div className="primary-font-color fs-7" style={{
                            position: "absolute",
                            top: "10px", left: "10px",
                            zIndex: 9, backgroundColor: "#ffba3c",
                            borderRadius: "4px",
                            padding: "0.2rem 0.5rem"
                          }}>
                            Featured
                          </div>
                        </div>

                        <ProgressiveImg
                          placeholderSrc={
                            this.state.productFeatures[2].productImage?.thumbnailImageFileName ?
                              this.state.productFeatures[2].productImage?.thumbnailImageFullURL :
                              this.state.defaultProductImage
                          }
                          src={this.state.productFeatures[2].productImage?.imageFullURL} />
                        {
                          this.renderProductPrice(this.state.productFeatures[2])
                        }
                      </Link>
                    </div>
                  }

                </div>

                <div style={{ clear: "both" }}>
                </div>
              </div>
            </div>
          </div>
        }

        <div className=" pt-1 pb-3 " style={{ backgroundColor: "#fff", }}>
          <div className="container">
            <div className="row">



              <div>
                <ScrollMenu

                  LeftArrow={LeftArrow}
                  RightArrow={RightArrow}
                // onWheel={this.onWheel}
                >
                  {
                    this.state.showqaceProductCategories?.map((showqaceCategory) =>
                    (

                      <ScrollShowqaceCategory
                        showqaceCategory={showqaceCategory}
                        itemId={showqaceCategory.id.toString()} // NOTE: itemId is required for track items
                        key={showqaceCategory.id}
                        fireClickAction={() => this.showqaceCategoryCardClicked(showqaceCategory)}
                      />

                      // <ScrollItem
                      //   fireClickAction={() => this.initAndOnPropChange(this.state.userProductResponse, productCategory.id)}
                      //   // publicUserResponse={this.state.userProductResponse.publicUserResponse}
                      //   category={productCategory}
                      //   itemId={productCategory.id.toString()}
                      //   key={productCategory.id}
                      // />

                    )
                    )
                  }


                </ScrollMenu>
              </div>

              {/* <div className="col-12" >
                  <h3>Product Categories</h3>
                </div> */}
              {/* {
                this.state.showqaceProductCategories?.length > 0 &&

                this.state.showqaceProductCategories.map((showqaceProductCategory, showqaceProductCategoryIndex) => (
                  <Fragment key={showqaceProductCategoryIndex} >
                    {
                      showqaceProductCategoryIndex == 5 && !this.state.isViewAll &&
                      <div className="col-4 col-lg-2 pointer" onClick={() => this.setState({ isViewAll: true })}  >
                        <img src={this.state.viewAllImageUrl} className="img-fluid" />
                        <p className="text-center">
                          View All
                        </p>
                      </div>
                    }
                    {
                      showqaceProductCategoryIndex < 5 &&

                      <div className="col-4 col-lg-2"  >
                        <Link className="primary-font-color no-underline" to={'/category/' + showqaceProductCategory.id}>
                          <img src={showqaceProductCategory.imageFullURL} className="img-fluid" />
                          <p className="text-center">
                            {showqaceProductCategory.name}
                          </p>
                        </Link>
                      </div>

                    }
                    {
                      showqaceProductCategoryIndex >= 5 && this.state.isViewAll &&

                      <div className="col-4 col-lg-2" >
                        <Link className="primary-font-color no-underline" to={'/category/' + showqaceProductCategory.id}>
                          <img src={showqaceProductCategory.imageFullURL} className="img-fluid" />
                          <p className="text-center">
                            {showqaceProductCategory.name}
                          </p>
                        </Link>
                      </div>

                    }

                  </Fragment>
                ))
              } */}




            </div>
          </div>

        </div >


        <div className="" >
          {
            this.state.showqaceProductCategories?.length > 0 &&
            this.state.showqaceProductCategories.map(showqaceProductCategory => (

              <div key={showqaceProductCategory.id} style={{ backgroundColor: "#fff", }}>
                <div className="container">
                  {
                    showqaceProductCategory.products?.length > 0 &&
                    <div className="row mt-1 p-2 pt-3 pb-3" style={{ backgroundColor: "#fff" }} >
                      <div className="col-8">
                        <Link className="primary-font-color no-underline" to={'/category/' + showqaceProductCategory.id}>
                          <h3>{showqaceProductCategory.name}</h3>
                        </Link>
                      </div>
                        <div className=" col-4 d-block d-md-none" style={{ textAlign: "right" }} >
                          <Link to={'/category/' + showqaceProductCategory.id} style={{ color: "#999", textDecoration: "none", fontWeight: 500 }} >
                            view all &gt;
                          </Link>
                      </div>
                      <LazyLoad offset={150} once height={200}>
                        <div className="">
                          <ScrollMenu

                            LeftArrow={LeftArrow}
                            RightArrow={RightArrow}
                          // onWheel={this.onWheel}
                          >
                            {
                              showqaceProductCategory.products?.map((product) =>
                              (

                                <ScrollProduct
                                  product={product}
                                  itemId={product.id.toString()} // NOTE: itemId is required for track items
                                  key={product.id}
                                  fireClickAction={() => this.productCardClicked(product)}
                                />

                                // <ScrollItem
                                //   fireClickAction={() => this.initAndOnPropChange(this.state.userProductResponse, productCategory.id)}
                                //   // publicUserResponse={this.state.userProductResponse.publicUserResponse}
                                //   category={productCategory}
                                //   itemId={productCategory.id.toString()}
                                //   key={productCategory.id}
                                // />

                              )
                              )
                            }
                          </ScrollMenu>
                        </div>
                      </LazyLoad>


                      {/* <button type="button" onClick={() => this.showqaceProductCategoryClicked(showqaceProductCategory)}
                        className="btn btn-third d-block d-md-none mt-3">
                        View All
                      </button> */}

                      <div className="d-none d-md-block text-end">
                        <button type="button" onClick={() => this.showqaceProductCategoryClicked(showqaceProductCategory)}
                          className="btn btn-third px-5">
                          View All
                        </button>
                      </div>


                    </div>
                  }
                </div>

              </div>
            ))

          }
        </div>

        <div className="pb-5" style={{ backgroundColor: "#fff" }}>
        </div>


      </div >
    );
  }
}

